export default __webpack_public_path__ + "static/media/example.4d69ebed.md";